import React from 'react'
import Step1 from './components/StepForm/Step1';
import "./styles/MultiStepForm.scss";

const ProjectMultiStepFormPage = () => <Step1 />

export default ProjectMultiStepFormPage;